<script>
  import {Pie, mixins} from 'vue-chartjs'

  const {reactiveProp} = mixins
  export default {
    extends: Pie,
    name: 'stats-pie-chart',
    mixins: [reactiveProp],
    mounted () {
      // Overwriting base render method with actual data.
      let options = {
        responsive: true,
        maintainAspectRatio: false,
        // rotation: -Math.PI,
        // cutoutPercentage: 30,
        // circumference: Math.PI,
        legend: {
          position: 'top'
        },
        animation: {
          animateRotate: false,
          animateScale: true
        },
        title: {
          display: false,
          text: 'Title here',
          fontSize: 24
        }
      }
      this.renderChart(this.chartData, options)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/StatsPieChart.vue